import axios from 'axios';

const DEFAULT_TIMEZONE = 'America/Santiago';

const sanitizeParams = (params = {}) => {
    const cleanParams = {};
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            cleanParams[key] = value;
        }
    });
    return cleanParams;
};

const buildError = (error) => {
    if (error.response) {
        const { status, data } = error.response;
        const serverMessage =
            data?.mensaje || data?.message || (status === 404 ? 'No se encontraron datos para el rango solicitado.' : `Error del servidor: ${status}`);
        return new Error(serverMessage);
    }
    if (error.request) {
        return new Error('No se recibió respuesta del servidor');
    }
    return new Error(error.message || 'Error inesperado al solicitar el informe.');
};

export const srvReportesEncuestasCreadas = async (userData, params = {}) => {
    const token = userData?.usuario?.token;
    if (!token) {
        throw new Error('Sesión no válida. Vuelve a iniciar sesión para acceder a los informes.');
    }

    const queryParams = sanitizeParams({
        agrupacion: params.agrupacion || 'mes',
        from: params.from,
        to: params.to,
        zonaHoraria: params.zonaHoraria || DEFAULT_TIMEZONE
    });

    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_BACKEND}/api/reportes/encuestas/creadas`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: queryParams
        });
        return response.data;
    } catch (error) {
        throw buildError(error);
    }
};

